export default class Template0 {
  static getData() {
    return [];
  }
}
